export const VALIDATE = 'VALIDATE';
export const HIDE_ACTION = 'HIDE_ACTION';
export const EXECUTE_ACTION = 'EXECUTE_ACTION';
export const CHANGE_PAGE = 'CHANGE_PAGE';
export const VALIDATE_PAGE = 'VALIDATE_PAGE';
export const VALIDATE_STEP = 'VALIDATE_STEP';
export const CLOSE_FORM_BELOW = 'CLOSE_FORM_BELOW';
export const RENDER_COMPONENT_IN_LIST = 'RENDER_COMPONENT_IN_LIST';
export const RENDER_COMPONENT_IN_FORM = 'RENDER_COMPONENT_IN_FORM';
export const UPDATE_COMPONENT = 'UPDATE_COMPONENT';
export const RESPONSE_TAB_VALIDATE = 'RESPONSE_TAB_VALIDATE';
export const CLOSE_DIALOG = 'CLOSE_DIALOG';
export const VALIDATE_TAB = 'VALIDATE_TAB';
export const CHANGE_TAB = 'CHANGE_TAB';
export const CHANGE_ACTIVE_TAB = 'CHANGE_ACTIVE_TAB';
export const CHANGE_STEP = 'CHANGE_STEP';
export const RESET_TAB = 'RESET_TAB';
export const RELOAD_TAB = 'RELOAD_TAB';
export const CHANGE_COMPONENT_IN_TAB = 'CHANGE_COMPONENT_IN_TAB';
export const OPEN_DRAWER_DINAMIC = 'OPEN_DRAWER_DINAMIC';
export const CLOSE_DRAWER_DINAMIC = 'CLOSE_DRAWER_DINAMIC';
export const SHOW_ACTIONS = 'SHOW_ACTIONS';
export const SHOW_BACKGROUND = 'SHOW_BACKGROUND';
export const SHOW_GROUPS = 'SHOW_GROUPS';
export const HIDE_GROUP = 'HIDE_GROUP';
export const ENABLED_FIELD = 'ENABLED_FIELD';
export const ENABLE_FOOTER = 'ENABLE_FOOTER';
export const SHOW_ITEM = 'SHOW_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const CHANGE_ORDER = 'CHANGE_ORDER';
export const RESET_BELOW = 'RESET_BELOW';
export const RECEIVE_ENTRY = 'RECEIVE_ENTRY';
export const ENABLE_CHILD = 'ENABLE_CHILD';
export const CLOSE_DIALOG_ELECTRONIC_SIGNATURE = 'CLOSE_DIALOG_ELECTRONIC_SIGNATURE';
export const RELOAD_COMPONENT_DEV = 'RELOAD_COMPONENT_DEV';
export const SELECT_COMPONENT_DEV = 'SELECT_COMPONENT_DEV';
export const CHILD_RELOAD = 'CHILD_RELOAD';
export const CHANGE_FIELD = 'CHANGE_FIELD';
export const UPDATE_MODULES_DEV = 'UPDATE_MODULES_DEV';
export const BACK_TO_TOP = 'BACK_TO_TOP';
export const ACTION_DEFAULT = 'ACTION_DEFAULT';
export const DISABLE_ACTIONS = 'DISABLE_ACTIONS';
export const CHANGE_MODE_INNER_PAGE = 'CHANGE_MODE_INNER_PAGE';
export const LOAD_DATA_VALUES_PAGINATE = 'LOAD_DATA_VALUES_PAGINATE';
export const HIDE_SUBPAGES = 'HIDE_SUBPAGES';
export const RELOAD_GRAPHICS = 'RELOAD_GRAPHICS';
